var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "simple-row" }, [
        _c("div", { staticClass: "left" }),
        _vm._v(" "),
        _c("div", { staticClass: "right" }, [
          !_vm.extracted
            ? _c(
                "a",
                {
                  staticClass: "swb-btn swb-btn-small",
                  on: { click: _vm.getAssetDeprTestResult }
                },
                [_vm._v("刷新")]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.extracted
            ? _c(
                "a",
                {
                  staticClass: "swb-btn swb-btn-small",
                  on: { click: _vm.doAssetDeprTest }
                },
                [_vm._v("重新测试")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "swb-btn swb-btn-small",
              on: { click: _vm.doExport }
            },
            [_vm._v("导出")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex label col-3" }, [
        _c("div", { staticClass: "form-group" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", { staticClass: "font14 Bold" }, [
              _vm._v(_vm._s(_vm.realComCount))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", { staticClass: "font14 Bold" }, [
              _vm._v(_vm._s(_vm.formCount || 0))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", { staticClass: "font14 Bold" }, [
              _vm._v(_vm._s(_vm.deprMonth || ""))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex label col-3" }, [
        _c("div", { staticClass: "form-group" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", { staticClass: "font14 Bold font-green" }, [
              _vm._v(_vm._s(_vm.testResult.execPassCount))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", { staticClass: "font14 Bold" }, [
              _vm._v(_vm._s(_vm.testResult.execOngoingCount))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _vm._m(5),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", { staticClass: "font14 Bold font-red" }, [
              _vm._v(_vm._s(_vm.testResult.execFailCount))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.assetDeprResultList, function(assetDeprResult, index) {
        return _c(
          "div",
          {
            staticClass: "mb10",
            staticStyle: { border: "1px solid #ebebeb", padding: "10px" }
          },
          [
            _c("div", { staticStyle: { width: "40px", float: "right" } }, [
              !_vm.extracted
                ? _c("i", {
                    staticClass: "icon iconfont icon-shanchu",
                    staticStyle: {
                      cursor: "pointer",
                      "font-size": "22px",
                      color: "#0c64eb"
                    },
                    on: {
                      click: function($event) {
                        _vm.doDel(index)
                      }
                    }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex label col-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _vm._m(6, true),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(assetDeprResult.realComName || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(7, true),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(assetDeprResult.realComCode || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(8, true),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.deprMonth || ""))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(9, true),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  assetDeprResult.message != null &&
                  assetDeprResult.message != ""
                    ? _c("span", { staticClass: "font-red" }, [
                        _vm._v(_vm._s(assetDeprResult.message || ""))
                      ])
                    : _c("span", [
                        _vm._v(_vm._s(assetDeprResult.execDesc || ""))
                      ])
                ])
              ])
            ]),
            _vm._v(" "),
            assetDeprResult.message == null || assetDeprResult.message == ""
              ? _c("table", { staticClass: "custom-tbl mt10" }, [
                  _vm._m(10, true),
                  _vm._v(" "),
                  _c("tbody", { staticClass: "body" }, [
                    _c("tr", { staticClass: "row align-left" }, [
                      _c("td", { staticClass: "align-center ellipsis" }, [
                        assetDeprResult.hasCenterCode
                          ? _c("span", { staticClass: "font-green" }, [
                              _vm._v("正确")
                            ])
                          : _c("span", { staticClass: "font-red" }, [
                              _vm._v("异常")
                            ])
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { width: "200px" } }, [
                        assetDeprResult.hasAssetKindSubject
                          ? _c("span", { staticClass: "font-green" }, [
                              _vm._v("正确")
                            ])
                          : _c("span", { staticClass: "font-red" }, [
                              _vm._v("异常")
                            ])
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { width: "200px" } }, [
                        assetDeprResult.deprMethodAvaliable
                          ? _c("span", { staticClass: "font-green" }, [
                              _vm._v("正确")
                            ])
                          : _c("span", { staticClass: "font-red" }, [
                              _vm._v("异常")
                            ])
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { width: "200px" } }, [
                        assetDeprResult.fiscalSealed
                          ? _c("span", { staticClass: "font-red" }, [
                              _vm._v("已锁账")
                            ])
                          : _c("span", { staticClass: "font-green" }, [
                              _vm._v("未锁账")
                            ])
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { width: "200px" } }, [
                        assetDeprResult.jointSpotAvailable
                          ? _c("span", { staticClass: "font-green" }, [
                              _vm._v("正确")
                            ])
                          : _c("span", { staticClass: "font-red" }, [
                              _vm._v("异常")
                            ])
                      ])
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            assetDeprResult.message == null || assetDeprResult.message == ""
              ? _c("table", { staticClass: "custom-tbl mt10" }, [
                  _vm._m(11, true),
                  _vm._v(" "),
                  _c("tbody", { staticClass: "body" }, [
                    _c("tr", { staticClass: "row" }, [
                      _c(
                        "td",
                        { staticClass: "align-center" },
                        [
                          _c("span", { staticClass: "fl ml5" }, [
                            _vm._v(_vm._s(assetDeprResult.assetsCount))
                          ]),
                          _vm._v(" "),
                          !_vm.extracted &&
                          parseInt(assetDeprResult.assetsCount || 0) > 0
                            ? _c(
                                "el-tag",
                                {
                                  staticClass: "fr",
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { type: "", effect: "dark" },
                                  on: {
                                    click: function($event) {
                                      _vm.viewAsset(assetDeprResult, false)
                                    }
                                  }
                                },
                                [_c("span", [_vm._v("查看明细")])]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("span", { staticClass: "fl ml5" }, [
                            _vm._v(_vm._s(assetDeprResult.deprCount))
                          ]),
                          _vm._v(" "),
                          !_vm.extracted &&
                          parseInt(assetDeprResult.deprCount || 0) > 0
                            ? _c(
                                "el-tag",
                                {
                                  staticClass: "fr",
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { type: "", effect: "dark" },
                                  on: {
                                    click: function($event) {
                                      _vm.viewAsset(assetDeprResult, true)
                                    }
                                  }
                                },
                                [_c("span", [_vm._v("查看明细")])]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("span", { staticClass: "fl ml5" }, [
                            _vm._v(_vm._s(assetDeprResult.deprPlanCount))
                          ]),
                          _vm._v(" "),
                          parseInt(assetDeprResult.deprPlanCount || 0) > 0
                            ? _c(
                                "el-tag",
                                {
                                  staticClass: "fr",
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { type: "", effect: "dark" },
                                  on: {
                                    click: function($event) {
                                      _vm.viewAssetDeprPlan(
                                        assetDeprResult,
                                        null
                                      )
                                    }
                                  }
                                },
                                [_c("span", [_vm._v("查看明细")])]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            assetDeprResult.message == null || assetDeprResult.message == ""
              ? _c("table", { staticClass: "custom-tbl mt10" }, [
                  _vm._m(12, true),
                  _vm._v(" "),
                  _c("tbody", { staticClass: "body" }, [
                    _c("tr", { staticClass: "row align-left" }, [
                      _c("td", { staticClass: "align-right ellipsis" }, [
                        _vm._v(
                          _vm._s(
                            parseFloat(assetDeprResult.deprWorth || 0).toFixed(
                              2
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "align-right" }, [
                        _vm._v(
                          _vm._s(
                            parseFloat(assetDeprResult.deprWorth2 || 0).toFixed(
                              2
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "align-right" },
                        [
                          _c("span", { staticClass: "mr10" }, [
                            _vm._v(
                              _vm._s(
                                parseFloat(
                                  assetDeprResult.deprExtraWorth || 0
                                ).toFixed(2)
                              )
                            )
                          ]),
                          _vm._v(" "),
                          parseFloat(assetDeprResult.deprExtraWorth || 0) > 0
                            ? _c(
                                "el-tag",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { type: "", effect: "dark" },
                                  on: {
                                    click: function($event) {
                                      _vm.viewAssetDeprPlan(
                                        assetDeprResult,
                                        true
                                      )
                                    }
                                  }
                                },
                                [_c("span", [_vm._v("查看明细")])]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ])
                ])
              : _vm._e()
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "font14 Bold" }, [_vm._v("测试公司数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "font14 Bold" }, [_vm._v("产生折旧单数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "font14 Bold" }, [_vm._v("折旧月份")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "font14 Bold" }, [_vm._v("测试通过数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "font14 Bold" }, [_vm._v("测试中数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "font14 Bold" }, [_vm._v("测试失败数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("公司名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("公司编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("折旧月份")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("测试结果")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row align-left" }, [
        _c("th", { staticClass: "align-center" }, [
          _vm._v("公司、利润中心、成本中心已配置")
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "200px" } }, [
          _vm._v("财务类别、科目已配置")
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "200px" } }, [_vm._v("满足折旧算法")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "200px" } }, [
          _vm._v("会计期间锁账状态")
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "200px" } }, [
          _vm._v("系统接口对接配置")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row align-left" }, [
        _c("th", [_vm._v("资产项目数量")]),
        _vm._v(" "),
        _c("th", [_vm._v("可折旧资产项目数量")]),
        _vm._v(" "),
        _c("th", [_vm._v("资产折旧计划数量")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row align-left" }, [
        _c("th", [_vm._v("计划折旧金额(元)")]),
        _vm._v(" "),
        _c("th", [_vm._v("实际折旧金额(元)")]),
        _vm._v(" "),
        _c("th", [_vm._v("计划外折旧金额(元)")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fd20f916", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd20f916","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/assetDepr/AssetDeprResult.vue
// module id = 2507
// module chunks = 0